function getSavedSearches() {
  const savedSearches = localStorage.getItem('savedSearches');

  if (!savedSearches) return [];
  try {
    const data = JSON.parse(savedSearches);
    return data[0] || {}
  } catch (e) {
    return [];
  }
}

function saveSearch(existingItems, newItem, remove) {
  const newPersistedSearch = {
    ...existingItems,
    [newItem.searchTerm]: {
      searchLabel: newItem.searchTerm,
      searchQuery: newItem.searchUrl
    }
  };
  if (remove) {
    delete newPersistedSearch[newItem.searchTerm];
  }
  localStorage.setItem('savedSearches', JSON.stringify([newPersistedSearch]));
  return newPersistedSearch;
}


export {getSavedSearches, saveSearch};
